import * as React from 'react';
import * as styles from './styles.css';

import { ArticleParagraph1 } from '@cian/ui-kit';

import { IconActionChevronDownSmall16 } from '@cian/ui-kit-design-tokens/icons';

export interface ICollapsedBlockProps extends React.PropsWithChildren {
  height: number;
  buttonText?: string;
  onClickCallback?(): void;
}

export const CollapsedBlock: React.FC<ICollapsedBlockProps> = ({ children, buttonText, height, onClickCallback }) => {
  const [isOpen, setIsOpen] = React.useState(false);

  const onClick = React.useCallback(() => {
    setIsOpen(true);
    if (onClickCallback) {
      onClickCallback();
    }
  }, [onClickCallback]);

  return (
    <>
      <div data-testid="CollapsedBlock" className={styles['container']} style={{ height: isOpen ? 'auto' : height }}>
        {children}
      </div>
      {!isOpen && (
        <button className={styles['button']} onClick={onClick}>
          <div className={styles['button_text']}>
            <ArticleParagraph1 color="text-main-default">{buttonText || 'Посмотреть всё'}</ArticleParagraph1>
          </div>
          <IconActionChevronDownSmall16 color="icon-main-default" />
        </button>
      )}
    </>
  );
};

CollapsedBlock.displayName = 'CollapsedBlock';
